import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import '../../../../styles/ConfirmBlockModal.css';
import { blockProspect } from '../../../../api/Prospect';
import LoadingOverlay from '../../../common/LoadingOverlay';
import { getMyId } from '../../../../utilities/identity';

interface ConfirmBlockModalProps {
    isOpen: boolean;
    prospectName: string;
    prospectUserId: any;
    propertyId: any;
    blockReason: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmBlockModal = ({
    isOpen,
    prospectName,
    prospectUserId,
    propertyId,
    blockReason,
    onClose,
    onConfirm,
}: ConfirmBlockModalProps) => {

    const [blockLoading, setBlockLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const prospectBlockCall = async () =>{
        setBlockLoading(true);
        let result = await blockProspect(
             {
                prospectUserId: parseInt(prospectUserId, 10),
                propertyId: propertyId,
                blockedBy: getMyId(),
                reason: blockReason
            }
        );

        if (
            result.success &&
            !result.error
        ) {
            setBlockLoading(false);
            setErrorMessage('');
            onConfirm();
        } else {
            setBlockLoading(false);
            setErrorMessage(
                result.error ||
                'Unable to update contact info. \
                Please refresh and try again.'
            );
        }

    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="confirm-block-modal">
            <ModalBody>
                {/* Close Icon */}
                <LoadingOverlay show={blockLoading} inBootstrapColumn={false} />
                <div className="modal-header">
                    <div className="close-icon" onClick={onClose}>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.92422 0.326953C1.48359 -0.108984 0.771094 -0.108984 0.330469 0.326953C-0.110156 0.762891 -0.105469 1.48008 0.330469 1.9207L8.90859 10.4988L0.330469 19.077C-0.110156 19.5176 -0.110156 20.2301 0.330469 20.666C0.771094 21.102 1.48359 21.1066 1.91953 20.666L10.4977 12.0879L19.0805 20.6707C19.5211 21.1113 20.2336 21.1113 20.6695 20.6707C21.1055 20.2301 21.1102 19.5176 20.6695 19.0816L12.0914 10.5035L20.6742 1.9207C21.1148 1.48008 21.1148 0.767578 20.6742 0.331641C20.2336 -0.104297 19.5211 -0.108984 19.0852 0.331641L10.507 8.90977L1.92422 0.326953Z"
                                fill="#333"
                            />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h4 className="modal-title">Are you sure you want to block?</h4>

                {/* User Name */}
                <h5 className="prospect-name">{prospectName}</h5>

                {/* Warning Message */}
                <p className="warning-text">
                    Blocking this user will prevent them from taking a tour at all properties associated with your company.
                </p>

                <p style={{ color: 'red' }}>{errorMessage}</p>

                {/* Action Buttons */}
                <div className="action-buttons">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-block" onClick={prospectBlockCall}>
                        Block
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ConfirmBlockModal;



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/confirmBlockModal.tsx